if( $('.reviewers').length )
{
	var swiper = new Swiper('.reviewers', {
		loop: false,
		spaceBetween: 10,
		slidesPerView: 1,
		breakpoints: {
			// when window width is >= 320px
			520: {
			slidesPerView: 2
			},
			// when window width is >= 640px
			640: {
			slidesPerView: 3
			}
		}
	});
}

if( $('.reviews').length )
{
	var swiper2 = new Swiper('.reviews', {
		loop: true,
		spaceBetween: 10,
		thumbs: {
			swiper: swiper
		}
	});
}